import Loadable from '@loadable/component';

const Affix = Loadable(() => import('rsuite/Affix'));
export default Affix;
